// AUth - REgistration
import RegisterFrom from '../Components/Pages/Auth/RegisterFrom';

// //Dashboard
import SamplePage from '../Components/Pages/PageLayout/SimplePage';

// User Profile
import TourMain from '../Components/Pages/Users';

//Patient
import PatientView from '../Components/Pages/Patient/PatientList/PatientView';
import PatientForm from '../Components/Pages/Patient/PatientList/PatientForm';
import PatientPage from '../Components/Pages/Patient/PatientPage/PatientIndex';
import DiagnosisInfo from '../Components/Pages/Patient/PatientPage/PatientTreatmentInfo/Diagnosis';

//Doctor
import DoctorIndex from '../Components/Pages/Doctor/DoctorIndex';
import DoctorForm from '../Components/Pages/Doctor/DoctorForm';

//Staff
import StaffIndex from '../Components/Pages/Staff/StaffIndex';
import StaffForm from '../Components/Pages/Staff/StaffForm';

//Inventory
import InventoryIndex from '../Components/Pages/Inventory/InventoryIndex';
import InventoryForm from '../Components/Pages/Inventory/InventoryForm';

//Pharmacy
import PharmacyIndex from '../Components/Pages/Pharmacy/PharmacyIndex';
import PharmacyForm from '../Components/Pages/Pharmacy/PharmacyForm';

//Accounts
import Accounts from '../Components/Pages/Accounts';
import ExpensesMonth from '../Components/Pages/Accounts/ExpenseTab/ExpensesMonth';

//Settings

//Treatment Settings
import DiagnosisType from '../Components/Pages/Settings/TreatmentSettings/DiagnosisType';
import Diagnosis from '../Components/Pages/Settings/TreatmentSettings/Diagnosis';
import TreatmentPlan from '../Components/Pages/Settings/TreatmentSettings/TreatmentPlan';
import TreatmentProcedure from '../Components/Pages/Settings/TreatmentSettings/TreatmentProcedure';
import TreatmentMethod from '../Components/Pages/Settings/TreatmentSettings/TreatmentMethod';

//General Settings
import InventoryCategory from '../Components/Pages/Settings/GeneralSettings/InventoryCategory'
import PharmacyCategory from '../Components/Pages/Settings/GeneralSettings/PharmacyCategory'
import StaffCategory from '../Components/Pages/Settings/GeneralSettings/StaffCategory'
import MedicalReportType from '../Components/Pages/Settings/GeneralSettings/MedicalReportType'
import DoctorDepartment from '../Components/Pages/Settings/GeneralSettings/DoctorDepartment'

import Permission from '../Components/Pages/UserManagement/permission';
import Role from '../Components/Pages/UserManagement/role';
import AppointmentInquiry from '../Components/Pages/Appoinments/AppointmentInquiry';
import ManageBranch from '../Components/Pages/Settings/Branch/ManageBranch';
import BranchForm from '../Components/Pages/Settings/Branch/BranchForm';

import InvoiceContain from '../Components/Pages/Billing/Invoice';
import BillingList from '../Components/Pages/Billing/BillingList';
import CheckOut from '../Components/Pages/Billing/CheckOut';
import TimeSlotForm from '../Components/Pages/Settings/TimeSlotManagement/TimeSlotForm';
import SlotDetails from '../Components/Pages/Settings/TimeSlotManagement/SlotDetails';

import Invoice from '../Components/Pages/Patient/PatientPage/PatientTreatmentInfo/Invoice';
import CheckOutPrescription from '../Components/Pages/Patient/PatientPage/PatientTreatmentInfo/CheckOut';
import InquiryForm from '../Components/Pages/InquiryForm';



export const routes = [
  //page
  { path: `${process.env.PUBLIC_URL}/authentication/register/:layout`, Component: <RegisterFrom /> },
  //Dashbord
  { path: `${process.env.PUBLIC_URL}/pages/sample-page/:layout`, Component: <SamplePage /> },
  { path: `${process.env.PUBLIC_URL}/users/userprofile/:layout`, Component: <TourMain /> },



  //Patient
  { path: `${process.env.PUBLIC_URL}/patientList/:layout`, Component: <PatientView /> },
  { path: `${process.env.PUBLIC_URL}/patientform/:layout`, Component: <PatientForm /> },
  { path: `${process.env.PUBLIC_URL}/patientinfo/:layout`, Component: <PatientPage /> },
  { path: `${process.env.PUBLIC_URL}/patientinfo/diagnosis/:layout`, Component: <DiagnosisInfo /> },
  //Doctor
  { path: `${process.env.PUBLIC_URL}/doctor/:layout`, Component: <DoctorIndex /> },
  { path: `${process.env.PUBLIC_URL}/doctorform/:layout`, Component: <DoctorForm /> },
  //Staff
  { path: `${process.env.PUBLIC_URL}/staff/:layout`, Component: <StaffIndex /> },
  { path: `${process.env.PUBLIC_URL}/staffform/:layout`, Component: <StaffForm /> },

  //Inventory
  { path: `${process.env.PUBLIC_URL}/inventory/:layout`, Component: <InventoryIndex /> },
  { path: `${process.env.PUBLIC_URL}/inventoryform/:layout`, Component: <InventoryForm /> },

  //Inquiry
  { path: `${process.env.PUBLIC_URL}/enquiryform/:layout`, Component: <InquiryForm /> },


  //Pharmacy
  { path: `${process.env.PUBLIC_URL}/pharmacy/:layout`, Component: <PharmacyIndex /> },
  { path: `${process.env.PUBLIC_URL}/pharmacyform/:layout`, Component: <PharmacyForm /> },

  //Accounts
  { path: `${process.env.PUBLIC_URL}/accounts/:layout`, Component: <Accounts /> },
  // { path: `${process.env.PUBLIC_URL}/accounts/:month`, Component: <ExpensesMonth /> },




  //Settings
  //Treatment Settings
  { path: `${process.env.PUBLIC_URL}/settings/diagnosistype/:layout`, Component: <DiagnosisType /> },
  { path: `${process.env.PUBLIC_URL}/settings/diagnosis/:layout`, Component: <Diagnosis /> },
  { path: `${process.env.PUBLIC_URL}/settings/treatmentplan/:layout`, Component: <TreatmentPlan /> },
  { path: `${process.env.PUBLIC_URL}/settings/treatmentprocedure/:layout`, Component: <TreatmentProcedure /> },
  { path: `${process.env.PUBLIC_URL}/settings/treatmentmethod/:layout`, Component: <TreatmentMethod /> },
  //General Settings
  { path: `${process.env.PUBLIC_URL}/settings/inventorycategory/:layout`, Component: <InventoryCategory /> },
  { path: `${process.env.PUBLIC_URL}/settings/pharmacycategory/:layout`, Component: <PharmacyCategory /> },
  { path: `${process.env.PUBLIC_URL}/settings/staffcategory/:layout`, Component: <StaffCategory /> },
  { path: `${process.env.PUBLIC_URL}/settings/doctordepartment/:layout`, Component: <DoctorDepartment /> },
  { path: `${process.env.PUBLIC_URL}/settings/medicalreporttype/:layout`, Component: <MedicalReportType /> },
  // { path: `${process.env.PUBLIC_URL}/settings/medicalreporttype/:layout`, Component: <MedicalReportType /> },

  //user_management
  { path: `${process.env.PUBLIC_URL}/user/role/:layout`, Component: <Role /> },
  { path: `${process.env.PUBLIC_URL}/user/permission/:layout`, Component: <Permission /> },

  //appointment
  { path: `${process.env.PUBLIC_URL}/appointments/:layout`, Component: <AppointmentInquiry /> },

  //brach
  { path: `${process.env.PUBLIC_URL}/settings/managebranch/:layout`, Component: <ManageBranch /> },
  { path: `${process.env.PUBLIC_URL}/settings/managebranchform/:layout`, Component: <BranchForm /> },
  { path: `${process.env.PUBLIC_URL}/settings/managetimeslot/:layout`, Component: <TimeSlotForm /> },
  { path: `${process.env.PUBLIC_URL}/settings/slotdetails/:layout`, Component: <SlotDetails /> },


  // { path: `${process.env.PUBLIC_URL}/settings/managebranchform/:layout`, Component: <BranchForm /> },
  { path: `${process.env.PUBLIC_URL}/billing/:layout`, Component: <BillingList /> },
  { path: `${process.env.PUBLIC_URL}/checkout/:layout`, Component: <CheckOut /> },
  { path: `${process.env.PUBLIC_URL}/invoice/:layout`, Component: <InvoiceContain /> },


  { path: `${process.env.PUBLIC_URL}/prescriptioninvoice/:layout`, Component: <Invoice /> },
  { path: `${process.env.PUBLIC_URL}/prescriptioncheckout/:layout`, Component: <CheckOutPrescription /> },
];
